module.exports = __webpack_public_path__ + "static/shop-09ca83e267d1176d737230a3b3d42d55.png";